import httpService from './httpService';
import { sendMessageUrl } from '../constants/apiEndPoints';

export function postMessageAPI(payload) {
    return httpService.post(sendMessageUrl, payload);
}
